import React from 'react';
import './bellIcon.scss';
import { connect } from 'react-redux';
import { ReactComponent as Bell } from '../../../../assets/bell.svg';
import { ReactComponent as Bell1 } from '../../../../assets/bell1.svg';
import { showNotiDropdown } from '../../../../redux/notifications/notifications-actions';
import { updateNoti } from '../../../../redux/notifications/notifications-actions';


const BellIcon = props => {
  
  return ( 
    <div className='cart-icon' onClick={props.showNotiDropdown}> 
      {
        props.showNotiDropdown1
        ? 
        (<Bell1 className='logo-header11' />)
        :
        (<Bell className='logo-header11' />)
      }
      
      {props.unseenNotisCount > 0 && 
      <span className='item-count'>{props.unseenNotisCount}</span>}
      
    </div>
  )
}

const mapStateToProps = state => ({
  unseenNotisCount: state.notifications.unseenNotisCount,
  showNotiDropdown1: state.notifications.showNotiDropdown,
  notisList: state.notifications.notisList
});

export default connect(mapStateToProps, { showNotiDropdown, updateNoti })(BellIcon);